import api from '../../utils/andromeda-api';
import axios from 'axios';

export async function saveNonMemberFormHeader({ orgId, content, userId }) {
  try {
    const response = await api.post('/organization/saveNonMemberFormHeader', {
      organizationId: orgId.toString(),
      content: content,
      savedBy: userId,
    });
    console.log('Saved nonmember header content');
    if (response?.data?.result) {
      return response?.data?.result;
    }
  } catch (e) {
    console.error(
      'Error saving nonmember header content [saveNonMemberFormHeader]',
      e
    );
    return false;
  }
}

export async function getNonMemberFormHeader(orgId) {
  try {
    const response = await api.get(
      `/organization/getNonMemberFormHeader/${orgId}`
    );
    console.log('Retrieved NonMemberFormHeader');
    if (response?.data?.result) {
      return response.data.result;
    }
  } catch (e) {
    console.error(
      'Error getting NonMemberFormHeader content [NonMemberFormHeader]',
      e
    );
    return false;
  }
  return false;
}

export async function getNonMemberFormPageData(hashId, acronym) {
  try {
    const response = await api.get(
      `/nonmemberform/details/${hashId}?acronym=${acronym}`
    );
    console.log('Retrieved NonMember page data');
    if (response?.data?.result) {
      return response.data.result;
    } else {
      return { error: true };
    }
  } catch (e) {
    return { error: true };
  }
}

export async function saveNonMemberContact(data) {
  try {
    // 1. Generate signature
    const signatureResponse = await fetch(
      `${process.env.REACT_APP_andromedaAPI}/nonmemberform/generate-signature`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          method: 'POST',
          body: data,
          originalUrl: '/nonmemberform/signup',
        }),
      }
    );

    // Check if signature generation was successful
    if (!signatureResponse.ok) {
      return {
        error: true,
        message: 'Failed to generate security signature. Please try again.',
      };
    }

    const signatureData = await signatureResponse.json();

    // Validate signature response
    if (
      !signatureData ||
      !signatureData.result ||
      !signatureData.result.headers
    ) {
      console.error('Invalid signature response:', signatureData);
      return {
        error: true,
        message: 'Invalid security signature received. Please try again.',
      };
    }

    let reqConfig = {
      headers: signatureData.result.headers,
    };

    // Use axios directly to bypass the interceptor that overwrites headers
    const response = await axios.post(
      `${process.env.REACT_APP_andromedaAPI}/nonmemberform/signup`,
      data,
      reqConfig
    );
    console.log('Saved nonmember contact', response);
    if (response?.data?.result) {
      return {
        result: response?.data?.result,
        message:
          response?.data?.message || 'Contact information saved successfully',
      };
    } else {
      return {
        error: true,
        message:
          response?.data?.message || 'Failed to save contact information',
      };
    }
  } catch (e) {
    console.error('Error saving nonmember contact [saveNonMemberContact]', e);
    return { error: true };
  }
}

export async function getNonMemberSignupDashboardData({
  orgId,
  startDate,
  endDate,
  range = 7,
}) {
  try {
    let url = `organization/track/nonmemberSignup/${orgId}`;
    if (startDate && endDate) {
      url += `?startDate=${startDate}&endDate=${endDate}`;
    } else {
      url += `?range=${range}`;
    }
    const response = await api.get(url);
    console.log(
      'Retrieved nonmember signup dashboard data',
      response.data.result
    );

    if (response?.data?.result) {
      return response.data.result;
    } else {
      return { error: true };
    }
  } catch (e) {
    console.error(
      'Error getting nonmember signup dashboard data [getNonMemberSignupDashboardData]',
      e
    );
    return { error: true };
  }
}
